var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(0 0.730469)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1332 19.1298L11.2665 16.2632C11.0221 16.0187 10.711 15.8965 10.3332 15.8965C9.95539 15.8965 9.64428 16.0187 9.39984 16.2632C9.1554 16.5076 9.03317 16.8187 9.03317 17.1965C9.03317 17.5743 9.1554 17.8854 9.39984 18.1298L13.1998 21.9298C13.4665 22.1965 13.7776 22.3298 14.1332 22.3298C14.4887 22.3298 14.7998 22.1965 15.0665 21.9298L22.5998 14.3965C22.8443 14.152 22.9665 13.8409 22.9665 13.4632C22.9665 13.0854 22.8443 12.7743 22.5998 12.5298C22.3554 12.2854 22.0443 12.1632 21.6665 12.1632C21.2887 12.1632 20.9776 12.2854 20.7332 12.5298L14.1332 19.1298ZM15.9998 30.0632C14.1554 30.0632 12.4221 29.7129 10.7998 29.0125C9.17762 28.312 7.76651 27.3623 6.56651 26.1632C5.36651 24.964 4.41673 23.5529 3.71717 21.9298C3.01762 20.3067 2.66739 18.5734 2.66651 16.7298C2.66562 14.8863 3.01584 13.1529 3.71717 11.5298C4.41851 9.90671 5.36828 8.4956 6.56651 7.29648C7.76473 6.09737 9.17584 5.1476 10.7998 4.44715C12.4238 3.74671 14.1572 3.39648 15.9998 3.39648C17.8425 3.39648 19.5758 3.74671 21.1998 4.44715C22.8238 5.1476 24.235 6.09737 25.4332 7.29648C26.6314 8.4956 27.5816 9.90671 28.2838 11.5298C28.9861 13.1529 29.3358 14.8863 29.3332 16.7298C29.3305 18.5734 28.9803 20.3067 28.2825 21.9298C27.5847 23.5529 26.635 24.964 25.4332 26.1632C24.2314 27.3623 22.8203 28.3125 21.1998 29.0138C19.5794 29.7152 17.8461 30.0649 15.9998 30.0632Z",
    fill: "#04236B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.a272900b5bd547004c2da20a84fb41f4.svg";
export { ForwardRef as ReactComponent };